//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			toggled: false,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		question: {
			type: String,
		},
		answer: {
			type: String,
		},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	filters: {},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/FaqListItem.vue